import { apiGet } from "./client";

export type DeskGlanceQueueMetric = {
  count: number;
  outstanding?: string;
};

export type DeskGlance = {
  toCollect: DeskGlanceQueueMetric | null;
  toDeliver: DeskGlanceQueueMetric | null;
  toPay: DeskGlanceQueueMetric | null;
  toReceive: DeskGlanceQueueMetric | null;
};

/** Owner glance aggregates — plan/44 */
export function fetchDeskGlance(companyRef: string, signal?: AbortSignal) {
  return apiGet<DeskGlance>(`/c/${companyRef}/desk/glance`, { signal });
}
